import { render, staticRenderFns } from "./StyleSetting.vue?vue&type=template&id=5b66646a&scoped=true&"
import script from "./StyleSetting.vue?vue&type=script&lang=js&"
export * from "./StyleSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66646a",
  null
  
)

export default component.exports